import React from 'react'
import { FormattedMessage } from 'react-intl'

export const titleMsg = (<FormattedMessage
  id="ErrorView.title"
  description="Heading displayed when an error occurs"
  defaultMessage="Sorry, something has gone wrong!"
/>)

export const tryAgainMsg = (<FormattedMessage
  id="ErrorView.tryAgain"
  description="A message asking the user to try refreshing the page"
  defaultMessage="Please try refreshing the page and trying again. If this issue continues,
                  please contact {feedbackEmail} for assistance."
  values={{
    feedbackEmail: <a href="mailto:feedback@rome2rio.com">feedback@rome2rio.com</a>,
  }}
/>)
